import React, {ComponentPropsWithoutRef, FC, ReactNode} from 'react';

import {twx} from '@/utils/tailwindUtils';

interface IBodyProps extends ComponentPropsWithoutRef<'div'> {
    children: ReactNode;
}

export const Body: FC<IBodyProps> = ({children, className, ...props}) => {
    return (
        <div className={twx('flex w-full max-w-[457px] flex-col gap-8', className)} {...props}>
            {children}
        </div>
    );
};
